import { render, staticRenderFns } from "./Contatto-edit.vue?vue&type=template&id=c3b4f4a6&"
import script from "./Contatto-edit.vue?vue&type=script&lang=js&"
export * from "./Contatto-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports